import { Navigate } from "react-router-dom";
import { StudentuseAuth } from "./StudentUseAuth";

export const StudentProtectedRoute = ({ children }) => {
  const { user } = StudentuseAuth();
  if (!user) {
    // user is not authenticated
    return <Navigate to="/Student/login" />;
  }
  return children;
};
